export var SemanticLayerFieldType;
(function (SemanticLayerFieldType) {
    SemanticLayerFieldType["TIME"] = "time";
    SemanticLayerFieldType["NUMBER"] = "number";
    SemanticLayerFieldType["STRING"] = "string";
    SemanticLayerFieldType["BOOLEAN"] = "boolean";
})(SemanticLayerFieldType || (SemanticLayerFieldType = {}));
export var SemanticLayerTimeGranularity;
(function (SemanticLayerTimeGranularity) {
    SemanticLayerTimeGranularity["NANOSECOND"] = "NANOSECOND";
    SemanticLayerTimeGranularity["MICROSECOND"] = "MICROSECOND";
    SemanticLayerTimeGranularity["MILLISECOND"] = "MILLISECOND";
    SemanticLayerTimeGranularity["SECOND"] = "SECOND";
    SemanticLayerTimeGranularity["MINUTE"] = "MINUTE";
    SemanticLayerTimeGranularity["HOUR"] = "HOUR";
    SemanticLayerTimeGranularity["DAY"] = "DAY";
    SemanticLayerTimeGranularity["WEEK"] = "WEEK";
    SemanticLayerTimeGranularity["MONTH"] = "MONTH";
    SemanticLayerTimeGranularity["QUARTER"] = "QUARTER";
    SemanticLayerTimeGranularity["YEAR"] = "YEAR";
})(SemanticLayerTimeGranularity || (SemanticLayerTimeGranularity = {}));
export const isSemanticLayerTimeDimension = (field) => 'granularity' in field;
// Semantic Layer Filters
export var SemanticLayerFilterBaseOperator;
(function (SemanticLayerFilterBaseOperator) {
    SemanticLayerFilterBaseOperator["IS"] = "IS";
    SemanticLayerFilterBaseOperator["IS_NOT"] = "IS_NOT";
})(SemanticLayerFilterBaseOperator || (SemanticLayerFilterBaseOperator = {}));
export var SemanticLayerFilterRelativeTimeValue;
(function (SemanticLayerFilterRelativeTimeValue) {
    SemanticLayerFilterRelativeTimeValue["TODAY"] = "TODAY";
    SemanticLayerFilterRelativeTimeValue["YESTERDAY"] = "YESTERDAY";
    SemanticLayerFilterRelativeTimeValue["LAST_7_DAYS"] = "LAST_7_DAYS";
    SemanticLayerFilterRelativeTimeValue["LAST_30_DAYS"] = "LAST_30_DAYS";
})(SemanticLayerFilterRelativeTimeValue || (SemanticLayerFilterRelativeTimeValue = {}));
export const isSemanticLayerBaseOperator = (operator) => operator === SemanticLayerFilterBaseOperator.IS ||
    operator === SemanticLayerFilterBaseOperator.IS_NOT;
export function isSemanticLayerRelativeTimeValue(value) {
    return (value === SemanticLayerFilterRelativeTimeValue.TODAY ||
        value === SemanticLayerFilterRelativeTimeValue.YESTERDAY ||
        value === SemanticLayerFilterRelativeTimeValue.LAST_7_DAYS ||
        value === SemanticLayerFilterRelativeTimeValue.LAST_30_DAYS);
}
export function isSemanticLayerRelativeTimeFilter(filter) {
    return (filter.fieldType === SemanticLayerFieldType.TIME &&
        'relativeTime' in filter.values &&
        isSemanticLayerRelativeTimeValue(filter.values.relativeTime));
}
export function isSemanticLayerExactTimeFilter(filter) {
    return (filter.fieldType === SemanticLayerFieldType.TIME &&
        'time' in filter.values);
}
//# sourceMappingURL=semanticLayer.js.map